import { z } from 'zod';

import { ExperienceVersion } from '../../experience/const';
import { buildQueryString } from '../../utils/querystring';
import { LanguageCode } from '../brand/brand';
import { makeEndpoint } from '../common';

export enum IncludedField {
  INCLUDED_LABEL = 'includedLabel',
}

export const ResponseListingIncludedSchema = z.object({
  id: z.string().uuid(),
  includedLabel: z.string(),
  order: z.number().nullable(),
});

const GetListingIncludedQuerySchema = z
  .object({
    experienceId: z.string().uuid(),
    language: z.nativeEnum(LanguageCode),
    resourceGroupCollectionId: z.string().uuid(),
    resourceGroupId: z.string().uuid(),
    version: z.nativeEnum(ExperienceVersion),
  })
  .partial({ experienceId: true, resourceGroupCollectionId: true, resourceGroupId: true })
  .strict()
  .refine(
    (value: {
      experienceId?: string | undefined;
      resourceGroupCollectionId?: string | undefined;
      resourceGroupId?: string | undefined;
    }) => !!value.experienceId || !!value.resourceGroupCollectionId || !!value.resourceGroupId,
    'At least one of experienceId, resourceGroupCollectionId, or resourceGroupId must be provided.',
  );

export const GetListingIncludedEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ query }: { query: z.input<typeof GetListingIncludedQuerySchema> }) =>
    `v1/listing-included?${buildQueryString(query)}`,
  responseSchema: z.object({ included: z.array(ResponseListingIncludedSchema) }).strict(),
  requestSchema: z.void(),
  querySchema: GetListingIncludedQuerySchema,
});

const PostListingIncludedRequestSchema = z
  .object({
    includedLabel: z.string(),
    experienceId: z.string().uuid(),
    resourceGroupCollectionId: z.string().uuid(),
    resourceGroupId: z.string().uuid(),
    order: z.number().nullable(),
    version: z.nativeEnum(ExperienceVersion),
  })
  .partial({ experienceId: true, resourceGroupCollectionId: true, resourceGroupId: true })
  .strict()
  .refine(
    (value: {
      experienceId?: string | undefined;
      resourceGroupCollectionId?: string | undefined;
      resourceGroupId?: string | undefined;
    }) => !!value.experienceId || !!value.resourceGroupCollectionId || !!value.resourceGroupId,
    'At least one of experienceId, resourceGroupCollectionId, or resourceGroupId must be provided.',
  );

export const PostListingIncludedEndpoint = makeEndpoint({
  method: 'POST',
  url: () => `v1/listing-included`,
  responseSchema: z.void(),
  requestSchema: PostListingIncludedRequestSchema,
  querySchema: z.void(),
});
